'use strict';

import moment from 'moment';

export default class GroupReportsCtrl {
  constructor($stateParams, FileSaveSvc, DatetimeSvc, GroupAuthSvc,
    GrpTypeSvc, GroupSvc, GrpAtrTypeSvc,
    MemberSvc, MemAtrTypeSvc, MemAtrSvc, PositionSvc, FinTxnSvc) {
    var groupId = $stateParams.groupId;
    this.groupId = groupId;


    // authorization
    GroupAuthSvc.validatePermission(groupId, 'group', 'E');

    this.FileSaveSvc = FileSaveSvc;
    this.moment = moment;
    this.DatetimeSvc = DatetimeSvc;
    this.GrpTypeSvc = GrpTypeSvc;
    this.GroupSvc = GroupSvc;
    this.GrpAtrTypeSvc = GrpAtrTypeSvc;
    this.MemberSvc = MemberSvc;
    this.MemAtrTypeSvc = MemAtrTypeSvc;
    this.MemAtrSvc = MemAtrSvc;
    this.PositionSvc = PositionSvc;
    this.FinTxnSvc = FinTxnSvc;

    this.reports = [
      {name: 'Membership'},
      {name: 'Leadership'},
      {name: 'Historical Membership', key: 'HistoricalMembership'},
      {name: 'Group'}
    ];

    // get init values
    this.getMemberAttributeTypes();
    this.getGroupTypes();

    if(GroupAuthSvc.hasPermission(groupId, 'group', 'F')) {
      this.reports.push({
        name: 'Historical Leadership',
        key: 'HistoricalLeadership'
      });
    }

    if(GroupAuthSvc.hasPermission(groupId, 'group', 'A')) {
      this.reports.push({
        name: 'Full Membership',
        key: 'FullMembership',
        // This property will be bound to the checkbox in the view
        currentMemberFilter: { value: true }
      });
      this.reports.push({name: 'Contact'});
      this.reports.push({
        name: 'Financial',
        timePeriodFilter: true
      });
    }
    var that = this;

    GroupSvc.getTimePeriods({groupId}).$promise.then(function(tp) {
      that.timePeriods = tp;
      //  ignore values that haven't started yet - without effective start
      var today = moment();
      tp = tp.filter(per => {
        return per.effectiveStart
        && today.isSameOrAfter(
          DatetimeSvc.parseUTCDate(per.effectiveStart)
        );
      });

      for(var i = 0; i < tp.length; i++) {
        var per = tp[i];
        // set default filter
        var effectiveStart = per.effectiveStart || per.start;
        if(today.isSameOrAfter(effectiveStart)
          && today.isSameOrBefore(
            that.DatetimeSvc.parseUTCDate(per.end, true)
          )) {
          that.tpFilter = per.id;
          break;
        }
      }
    });
  }

  runReport(rep) {
    rep.status = 'started';
    var reportKey = rep.key || rep.name;
    var getDataFn = 'get' + reportKey + 'Data';
    // run the report then set to complete
    this[getDataFn]().then(function(data) {
      rep.data = data;
      rep.status = 'complete';
    });
  }

  downloadReport(rep, group) {
    var reportKey = rep.key || rep.name;
    var csvObj = { data: rep.data, fields: this[reportKey + 'Fields']};
    var filename = group.name + ' ' + rep.name;
    if(rep.timePeriodFilter && this.timePeriods) {
      const timePeriod = this.timePeriods.find(
        tp => tp.id === this.tpFilter
      );
      if(timePeriod && timePeriod.name) {
        filename = timePeriod.name + ' ' + filename;
      }
    }
    this.FileSaveSvc.saveAsCsv(csvObj, filename, true);
  }

  //////////////////////////////////////////////////////////////////////////////
  // Get values required for reports
  //////////////////////////////////////////////////////////////////////////////
  getMemberAttributeTypes() {
    var that = this;
    that.MemAtrTypeSvc.query({groupId: that.groupId}).$promise
      .then(function(memAtrType) {
        that.memAtrTypes = memAtrType;

        for(var j = 0; j < memAtrType.length; j++) {
        // add reports for custom rel attributes
          if(memAtrType[j].responseType === 'rel') {
            that.getRelDataFn(memAtrType[j]);
          }
        }
      });
  }

  getGroupAttributeTypes() {
    var that = this;
    return that.GrpAtrTypeSvc.getDefinedBy({groupId: 1});
  }

  getGroupTypes() {
    var that = this;
    that.GrpTypeSvc.getDesc({groupId: that.groupId}).$promise
      .then(gt => {
        that.groupTypes = gt;
      });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Member Report
  //////////////////////////////////////////////////////////////////////////////
  getMembershipData() {
    var that = this;
    // set membership fields
    var MembershipFields = [
      {label: 'District', value: 'districts'},
      {label: 'Club', value: 'clubs'},
      {label: 'Member Type', value: 'memberTypes'},
      {label: 'Member Since', value: 'memberSince'},
      {label: 'First Name', value: 'fname'},
      {label: 'Last Name', value: 'lname'},
      {label: 'Email', value: 'email'},
      {label: 'Gender', value: 'gender'},
      {label: 'Birth Day', value: 'birthday'},
      {label: 'Birth Month', value: 'birthmonth'},
      {label: 'Birth Year', value: 'birthyear'}
    ];
    // pass tz as queryString param to server for active query
    var tz = that.moment().utcOffset();
    var gt = that.groupTypes;
    for(var i = gt.length - 1; i >= 0; i--) {
      MembershipFields.unshift({
        label: gt[i].name,
        value: 'groupsByTypeId.' + gt[i].id
      });
    }
    for(var j = 0; j < this.memAtrTypes.length; j++) {
      if(this.memAtrTypes[j].responseType !== 'rel'
         && this.memAtrTypes[j].isActive) {
        MembershipFields.push({
          label: this.memAtrTypes[j].name,
          value: 'a' + this.memAtrTypes[j].id}
        );
      }
    }
    that.MembershipFields = MembershipFields;
    return that.MemberSvc.queryReport({groupId: that.groupId, tz}).$promise
      .then(that.prepMembership.bind(that));
  }

  prepMembership(members) {
    var that = this;
    const today = moment();
    return members.map(function(m) {
      m.memberSince = that.DatetimeSvc.dateToString(m.memberSince,
        'YYYY-MM-DD');

      // Calculate yearsOfMembership
      if(m.memberSince) {
        // Use moment to calculate diff in years
        const since = moment(m.memberSince, 'YYYY-MM-DD');
        m.yearsOfMembership = since.isValid() ? today.diff(since, 'years') : '';
      } else {
        m.yearsOfMembership = '';
      }

      if(m.inactiveDate) {
        m.inactiveDate = that.DatetimeSvc.endDateToString(m.inactiveDate,
          'YYYY-MM-DD');
      }

      if(m.updated_at) {
        // eslint-disable-next-line camelcase
        m.updated_at = that.DatetimeSvc.dateToString(m.updated_at,
          'YYYY-MM-DD');
      }
      var membershipArrayKeys = ['memberTypes', 'districts',
        'clubs', 'activeMemberTypes'];
      for(var ma = 0; ma < membershipArrayKeys.length; ma++) {
        var arrayKey = membershipArrayKeys[ma];
        if(m[arrayKey]) {
          m[arrayKey] = m[arrayKey].filter(n => n).join('; ');
        }
      }
      return m;
    });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Historical Member Report (View only)
  //////////////////////////////////////////////////////////////////////////////
  getHistoricalMembershipData() {
    var that = this;
    // set membership fields
    var HistoricalMembershipFields = [
      {label: 'District', value: 'districts'},
      {label: 'Club', value: 'clubs'},
      {label: 'Member Type', value: 'memberTypes'},
      {label: 'Active Member Type', value: 'activeMemberTypes'},
      {label: 'Member Since', value: 'memberSince'},
      {label: 'Member Status', value: 'memberStatus'},
      {label: 'Inactive Date', value: 'inactiveDate'},
      {label: 'Deceased', value: 'isDeceased'},
      {label: 'First Name', value: 'fname'},
      {label: 'Last Name', value: 'lname'},
      {label: 'Email', value: 'email'},
      {label: 'Gender', value: 'gender'},
      {label: 'Birth Day', value: 'birthday'},
      {label: 'Birth Month', value: 'birthmonth'},
      {label: 'Birth Year', value: 'birthyear'}
    ];
    // pass tz as queryString param to server for active query
    var tz = that.moment().utcOffset();
    that.HistoricalMembershipFields = HistoricalMembershipFields;
    return that.MemberSvc.queryHistoricalReport({groupId: that.groupId, tz})
      .$promise.then(that.prepMembership.bind(that));
  }

  //////////////////////////////////////////////////////////////////////////////
  // Full Member Report
  //////////////////////////////////////////////////////////////////////////////
  getFullMembershipData() {
    var that = this;
    // set membership fields
    var FullMembershipFields = [
      {label: 'District', value: 'districts'},
      {label: 'Club', value: 'clubs'},
      {label: 'Member Type', value: 'memberTypes'},
      {label: 'Active Member Type', value: 'activeMemberTypes'},
      {label: 'Member Since', value: 'memberSince'},
      {label: 'Member Status', value: 'memberStatus'},
      {label: 'Membership Years', value: 'yearsOfMembership'},
      {label: 'Inactive Date', value: 'inactiveDate'},
      {label: 'Payment Status', value: 'paymentStatus'},
      {label: 'Deceased', value: 'isDeceased'},
      {label: 'First Name', value: 'fname'},
      {label: 'Last Name', value: 'lname'},
      {label: 'Email', value: 'email'},
      {label: 'Gender', value: 'gender'},
      {label: 'Birth Day', value: 'birthday'},
      {label: 'Birth Month', value: 'birthmonth'},
      {label: 'Birth Year', value: 'birthyear'},
      {label: 'Email', value: 'email'},
      {label: 'Address Line 1', value: 'lines.0'},
      {label: 'Address Line 2', value: 'lines.1'},
      {label: 'Address Line 3', value: 'lines.2'},
      {label: 'Address Line 4', value: 'lines.3'},
      // lines: {type: 'array', items: {type: 'string'}},
      {label: 'City/Locality', value: 'locality'},
      {label: 'State/Region', value: 'region'},
      {label: 'Postal Code', value: 'postalCode'},
      {label: 'Country', value: 'country'},
      {label: 'Address Type', value: 'type'},
      // {label: 'Last Updated By', value: 'updatedBy'},
      {label: 'Last Updated At', value: 'updated_at'}
    ];
    // pass tz as queryString param to server for active query
    var tz = that.moment().utcOffset();
    that.FullMembershipFields = FullMembershipFields;
    // Find the Full Membership report object to get the filter value
    var fullMembershipReport = (that.reports || []).find(function(r) {
      return r.key === 'FullMembership';
    });
    var currentMemberOnly = fullMembershipReport
      && fullMembershipReport.currentMemberFilter
      ? fullMembershipReport.currentMemberFilter.value
      : true;

    return that.MemberSvc.queryFullReport({
      groupId: that.groupId,
      tz,
      currentMemberOnly
    })
      .$promise
      .then(function(members) {
        return that.prepMembership(members);
      });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Leadership Report
  //////////////////////////////////////////////////////////////////////////////
  getLeadershipData() {
    var that = this;
    that.LeadershipFields = [
      {label: 'Group Type', value: 'group.type.name'},
      {label: 'Group', value: 'group.name'},
      {label: 'Position', value: 'type'},
      {label: 'First Name', value: 'person.fname'},
      {label: 'Last Name', value: 'person.lname'},
      {label: 'Email', value: 'person.emails.0.email'},
      {label: 'Custom Position?', value: 'isCustom'},
      {label: 'Start', value: 'start'},
      {label: 'End', value: 'end'},
      // {label: 'Last Updated By', value: 'updatedBy'},
      {label: 'Last Updated At', value: 'updated_at'}
    ];
    var tz = that.moment().utcOffset();
    return that.PositionSvc.getDescendents({groupId: that.groupId, tz}).$promise
      .then(function(positions) {
        return positions.map(function(p) {
          p.type = p.type && p.type.name ? p.type.name : p.customType;
          p.isCustom = typeof p.customType === 'string';

          // update datetimes
          if(p.start) {
            p.start = that.DatetimeSvc.dateToString(p.start, 'YYYY-MM-DD');
          }

          if(p.end) {
            p.end = that.DatetimeSvc.endDateToString(p.end, 'YYYY-MM-DD');
          }

          if(p.updated_at) {
          // eslint-disable-next-line camelcase
            p.updated_at = that.DatetimeSvc.dateToString(p.updated_at,
              'YYYY-MM-DD');
          }
          return p;
        });
      });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Historical Leadership Report
  //////////////////////////////////////////////////////////////////////////////
  getHistoricalLeadershipData() {
    var that = this;
    that.HistoricalLeadershipFields = [
      {label: 'Group Type', value: 'group.type.name'},
      {label: 'Group', value: 'group.name'},
      {label: 'Position', value: 'type'},
      {label: 'First Name', value: 'person.fname'},
      {label: 'Last Name', value: 'person.lname'},
      {label: 'Email', value: 'person.emails.0.email'},
      {label: 'Custom Position?', value: 'isCustom'},
      {label: 'Start', value: 'start'},
      {label: 'End', value: 'end'},
      // {label: 'Last Updated By', value: 'updatedBy'},
      {label: 'Last Updated At', value: 'updated_at'}
    ];
    var tz = that.moment().utcOffset();
    var activeOnly = false;
    return that.PositionSvc
      .getDescendents({groupId: that.groupId, tz, activeOnly})
      .$promise.then(function(positions) {
        return positions.map(function(p) {
          p.type = p.type && p.type.name ? p.type.name : p.customType;
          p.isCustom = typeof p.customType === 'string';

          // update datetimes
          if(p.start) {
            p.start = that.DatetimeSvc.dateToString(p.start, 'YYYY-MM-DD');
          }

          if(p.end) {
            p.end = that.DatetimeSvc.endDateToString(p.end, 'YYYY-MM-DD');
          }

          if(p.updated_at) {
          // eslint-disable-next-line camelcase
            p.updated_at = that.DatetimeSvc.dateToString(p.updated_at,
              'YYYY-MM-DD');
          }
          return p;
        });
      });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Contact Report
  //////////////////////////////////////////////////////////////////////////////
  getContactData() {
    var that = this;
    // set membership fields
    var ContactFields = [
      {label: 'Member Type', value: 'memberTypes'},
      {label: 'Member Since', value: 'memberSince'},
      {label: 'First Name', value: 'fname'},
      {label: 'Last Name', value: 'lname'},
      {label: 'Gender', value: 'gender'},
      {label: 'Birth Day', value: 'birthday'},
      {label: 'Birth Month', value: 'birthmonth'},
      {label: 'Birth Year', value: 'birthyear'},
      {label: 'Email', value: 'email'},
      {label: 'Address Line 1', value: 'lines.0'},
      {label: 'Address Line 2', value: 'lines.1'},
      {label: 'Address Line 3', value: 'lines.2'},
      {label: 'Address Line 4', value: 'lines.3'},
      // lines: {type: 'array', items: {type: 'string'}},
      {label: 'City/Locality', value: 'locality'},
      {label: 'State/Region', value: 'region'},
      {label: 'Postal Code', value: 'postalCode'},
      {label: 'Country', value: 'country'},
      {label: 'Address Type', value: 'type'},
    ];
    // pass tz as queryString param to server for active query
    var tz = that.moment().utcOffset();
    var gt = that.groupTypes;
    for(var i = gt.length - 1; i >= 0; i--) {
      ContactFields.unshift({
        label: gt[i].name,
        value: 'groupsByTypeId.' + gt[i].id
      });
    }
    that.ContactFields = ContactFields;
    return that.MemberSvc.queryContactReport({groupId: that.groupId, tz})
      .$promise
      .then(that.prepMembership.bind(that)); // same prep as member report
  }

  //////////////////////////////////////////////////////////////////////////////
  // Custom Attributes Relationships Report (ex. Sponsors)
  //////////////////////////////////////////////////////////////////////////////
  getRelDataFn(memAtrType) {
    var that = this;
    if(memAtrType.relToModel === 'Member') {
      var name = memAtrType.name;
      var helpText = `The Groups show the Member's groups.  If the ${name} belong to a different group that will not be reflected in the report.`;
      that.reports.push({name, helpText});
      var dataFnName = 'get' + name + 'Data';
      that[dataFnName] = that.getMemberRelDataFn(memAtrType);
    }
  }

  getMemberRelDataFn(memAtrType) {
    var that = this;
    var matName = memAtrType.name;
    return function() {
      var MemberRelFields = [
        {label: 'Member First Name', value: 'fname'},
        {label: 'Member Last Name', value: 'lname'},
        {label: 'Member Email', value: 'email'},
        // add isCurrent for filtering
        {label: 'Current Member?', value: 'isCurrent'},
        {label: 'Member Since', value: 'memberSince'}
      ];
      var tz = that.moment().utcOffset();
      var gt = that.groupTypes;
      // add groups to beginning of csv
      for(var i = gt.length - 1; i >= 0; i--) {
        MemberRelFields.unshift({label: gt[i].name,
          value: 'groupsByTypeId.' + gt[i].id});
      }
      // add member custom attributes
      var requestedMemberAtr = [];
      for(var j = 0; j < that.memAtrTypes.length; j++) {
        // add reports based on custom rel attributes
        /**
         * temporary hack to include member ids
         * TODO: provide better options of which attributes to include
         */
        if(that.memAtrTypes[j].isAutoIncrement === true) {
          MemberRelFields.push({label: that.memAtrTypes[j].name,
            value: 'a' + that.memAtrTypes[j].id});
          requestedMemberAtr.push(that.memAtrTypes[j].id);
        }
      }

      // add related
      MemberRelFields
        .push(
          {label: matName + ' First Name', value: 'p2_fname'},
          {label: matName + ' Last Name', value: 'p2_lname'},
          {label: matName + ' Email', value: 'p2_email'}
        );
      // add sponsor custom attributes
      for(var k = 0; k < that.memAtrTypes.length; k++) {
        // add reports based on custom rel attributes
        if(that.memAtrTypes[k].isAutoIncrement === true) {
          MemberRelFields.push({label: that.memAtrTypes[k].name,
            value: 'p2_a' + that.memAtrTypes[k].id});
        }
      }
      // add index for multi relationships
      MemberRelFields.push({label: matName + ' #', value: 'index'});
      that[matName + 'Fields'] = MemberRelFields;
      var params = {groupId: that.groupId, id: memAtrType.id,
        tz, matIds: JSON.stringify(requestedMemberAtr)};
      return that.MemAtrSvc.queryMemberRel(params).$promise
        .then(function(memRelData) {
        // convert memberSince to date
          return memRelData.map(function(m) {
            m.memberSince = that.DatetimeSvc.dateToString(m.memberSince,
              'YYYY-MM-DD');
            return m;
          });
        });
    };
  }

  //////////////////////////////////////////////////////////////////////////////
  // Financials Report
  //////////////////////////////////////////////////////////////////////////////
  getFinancialData() {
    var that = this;
    that.FinancialFields = [
      {label: 'Group', value: 'fromGroup.name'},
      {label: 'Type', value: 'type'},
      // {label: 'Paid By', value: 'paidBy.displayName'},
      {label: 'Status', value: 'status'},
      {label: 'Submitted By', value: 'submittedBy.displayName'},
      {label: 'Receipt ID', value: 'id'},
      {label: 'Amount', value: 'amount'},
      {label: 'Processing Fee', value: 'processFeeAmount'},
      {label: 'Price Date', value: 'pricedOn'},
      {label: 'Submit Date', value: 'submittedAt'},
      {label: 'Accept Date', value: 'acceptedAt'},
      {label: 'Item Name', value: 'transaction.name'},
      {label: 'Item Amount', value: 'transaction.amount'},
      {label: 'Item Member', value: 'transaction.person.displayName'}
    ];

    return that.FinTxnSvc.queryReport({
      groupId: that.groupId,
      timePeriodId: that.tpFilter
    })
      .$promise
      .then(function(finTxnData) {
        return finTxnData
          .filter(function(ft) {
            return ft.rejectedAt === null;
          })
          .map(function(ft) {
            // status
            ft.status = 'Submitted - Pending Approval';
            if(ft.rejectedAt) {
              ft.status = 'Rejected';
            } else if(ft.acceptedAt) {
              ft.status = 'Paid';
            }

            // remove fees when increased for members
            if(ft.isIncreasedByFee) {
              ft.processFeeAmount = null;
            }
            // amounts - display
            var amountKeys = ['amount', 'processFeeAmount'];
            for(var aIndex in amountKeys) {
              var amtKey = amountKeys[aIndex];
              ft[amtKey] = (ft[amtKey] / 100).toFixed(2);
            }
            if(ft.transaction && ft.transaction.amount) {
              var transAmt = -1 * ft.transaction.amount / 100;
              ft.transaction.amount = transAmt.toFixed(2);
            }
            // update datetimes
            var dateKeys = ['acceptedAt', 'submittedAt'];
            for(var dIndex in dateKeys) {
              var dkey = dateKeys[dIndex];
              if(ft[dkey]) {
                ft[dkey] = moment(ft[dkey]).format('YYYY-MM-DD');
              }
            }
            // pricedOn
            ft.pricedOn = that.DatetimeSvc.parseUTCDate(ft.pricedOn)
              .format('YYYY-MM-DD');


            return ft;
          });
      });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Group Report
  //////////////////////////////////////////////////////////////////////////////
  getGroupData() {
    var that = this;
    // set group fields
    var GroupFields = [
      {label: 'District', value: 'district'},
      {label: 'Club', value: 'club'},
      {label: 'Description', value: 'description'},
      {label: 'Active', value: 'isActive'}
    ];

    that.GroupFields = GroupFields;
    return that.getGroupAttributeTypes().$promise.then(function(grpAtrTypes) {
      for(var j = 0; j < grpAtrTypes.length; j++) {
        if(grpAtrTypes[j].responseType !== 'rel'
           && grpAtrTypes[j].isActive) {
          GroupFields.push({
            label: grpAtrTypes[j].name,
            value: 'a' + grpAtrTypes[j].id}
          );
        }
      }
      return that.GroupSvc.queryReport({groupId: that.groupId}).$promise
        .then(function(grpData) {
          for(var k = 0; k < grpData.length; k++) {
            var grp = grpData[k];

            // append group attributes
            // (Note: done on client side instead of server)
            for(var grpAtr in grp.json) {
              grp[grpAtr] = grp.json[grpAtr];
            }

            // set district or club
            var grpTypeId = grp.typeId;
            if(grpTypeId === 1) {
              grp.district = grp.name;
            } else if(grpTypeId === 2) {
              grp.district = grp.parentName;
              grp.club = grp.name;
            }
          }
          return grpData;
        });
    });
  }
}

GroupReportsCtrl.$inject = [
  '$stateParams',
  'FileSaveSvc',
  'DatetimeSvc',
  'GroupAuthSvc',
  'GrpTypeSvc',
  'GroupSvc',
  'GrpAtrTypeSvc',
  'MemberSvc',
  'MemAtrTypeSvc',
  'MemAtrSvc',
  'PositionSvc',
  'FinTxnSvc'
];
